export default {
  app: {
    name: '.Net Core 测试'
  },
  navbar: {
    logOut: '退出登录',
    Home: '首页',
    switchLanguage: '切换语言',
    ChangePassword: '修改密码'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    accountNotLess2: '登陆账号不能小于2位',
    passwordNotLess6: '密码不能小于6位',
  },
  form: {
    add: "新增",
    modify: "修改",
    delete: "删除",
    reload: "刷新",
    import: "导入",
    export: "导出",
    print: "打印",
    submit: "提交",
    reset: "重置",
    clear: "清空",
  },
  global: {
    prompt: '提示'
  }
}